import WorkoutHistory from './WorkoutHistory';

export default WorkoutHistory;
